export default __webpack_public_path__ + "static/media/image.0fe86f15.svg";